"use client";
import { useEffect } from "react";
import Script from "next/script";
import { usePathname } from "next/navigation";
import { logError } from "@jetblue/dotcom-fe-logger";
import type { DynamicYieldProperites } from ".";
import { setPageContext } from ".";
import { subscribeDynamicYieldConsent } from "./consent";
import {
  DEFAULT_DYNAMIC_YIELD_SECTION_ID,
  DYNAMIC_YIELD_CDN_ORIGIN,
} from "./constants";

export const DynamicYieldClient = ({
  sectionId,
  language,
}: DynamicYieldProperites) => {
  const pathname = usePathname();
  const effectiveSectionId = sectionId ?? DEFAULT_DYNAMIC_YIELD_SECTION_ID;

  useEffect(() => {
    if (!sectionId) {
      void logError({
        message: "DynamicYieldService initialized without sectionId defined",
      });
    }
  }, [sectionId]);

  useEffect(() => {
    const unsubscribeFromConsent = subscribeDynamicYieldConsent();

    return () => {
      unsubscribeFromConsent();
    };
  }, []);

  useEffect(() => {
    setPageContext({
      currentUrl: globalThis.location.href,
      isHomePage: globalThis.location.pathname === "/",
      language,
    });
  }, [pathname]);

  return (
    <>
      <Script
        src={`${DYNAMIC_YIELD_CDN_ORIGIN}/api/${effectiveSectionId}/api_dynamic.js`}
      />
      <Script
        src={`${DYNAMIC_YIELD_CDN_ORIGIN}/api/${effectiveSectionId}/api_static.js`}
      />
    </>
  );
};
